// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SpinnerContainer":"SpinnerContainer_2X7H2_v16-5-1","Spinner":"Spinner_3cSdq_v16-5-1","Spinner__ColorGrayDark50":"Spinner__ColorGrayDark50_3M7NK_v16-5-1"};